module.exports = __webpack_public_path__ + "static/the-amateur-ebc1ff49ee4d93e35a02f4467044d755.jpg";